import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  isLoading: false,
  viewSingleProduct: {},
  deleteProductStatus: "",
  deleteProductError: "",
  isDeleteModalOpen: false,
  isSuccess: false,
  isError: false,
  message: "",
};

export const deleteProduct = createAsyncThunk(
  "products/delete_product",
  async (productId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_KEY}/product/delete_product`,
        {
          data: { id: productId },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const deleteProductSlice = createSlice({
  name: "deleteProducts",
  initialState,
  reducers: {
    openDeleteModal: (state, action) => {
      state.isDeleteModalOpen = true;
      state.viewSingleProduct = action.payload;
      // state.deleteProductStatus = "success";
      state.deleteProductError = "";
    },
    closeDeleteModal: (state) => {
      state.isDeleteModalOpen = false;
      state.viewSingleProduct = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(deleteProduct.pending, (state) => {
      state.isLoading = true;
      state.deleteProductStatus = "pending";
      state.deleteProductError = "";
    });
    builder.addCase(deleteProduct.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.isDeleteModalOpen = false;
      state.deleteProductStatus = "success";
      state.deleteProductError = "";
      state.viewSingleProduct = {};
    });
    builder.addCase(deleteProduct.rejected, (state, action) => {
      state.isLoading = true;
      state.isError = true;
      state.deleteProductStatus = "rejected";
      state.deleteProductError = action.payload;
      console.error(action.error);
    });
  },
});
export const { openDeleteModal, closeDeleteModal } = deleteProductSlice.actions;
export default deleteProductSlice.reducer;
